/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import { useCallback, useMemo } from 'react';
import { parsePath, type To } from 'react-router-dom';
import { toPath } from './appPaths';
import { useShellNavigationContext } from './ShellNavigationContext';

/**
 * Shell location and navigation for providers that sit above the window layer, where no router
 * exists. Same shape as react-router's `useLocation` / `useNavigate` for absolute targets.
 */
export function useShellNavigation() {
  const { location: shellLocation, navigate: navigateShell } = useShellNavigationContext();
  const location = useMemo(() => {
    const { pathname = '/', search = '', hash = '' } = parsePath(shellLocation.path);
    return { hash, key: shellLocation.key, pathname, search, state: shellLocation.state };
  }, [shellLocation]);
  const navigate = useCallback(
    (to: To, { replace = false, state }: { replace?: boolean; state?: unknown } = {}) =>
      navigateShell(toPath(to), state, replace),
    [navigateShell],
  );

  return { location, navigate };
}
